import React from 'react';
import { RelatedHotels } from '@utils/Graphite/graphite';
import Link from 'next/link';
import { useEvents } from '@events/EventsProvider';
import { CLICK_DLP_POPULAR_HOTEL } from '@constants/amplitudeEvents';
import HotelDetails from '@customTypes/hotel-details';

type Props = {
  currentHotel: HotelDetails;
  hotels: Array<RelatedHotels>;
};

export default function GraphiteRelatedHotels({ currentHotel, hotels }: Props) {
  const { track } = useEvents();

  const handleOnClick = (hotel: RelatedHotels) => {
    track(CLICK_DLP_POPULAR_HOTEL, {
      current_hotel: currentHotel.name,
      clicked_hotel_name: hotel.title,
    });
  };

  return (
    <div className="flex flex-col w-full pl-4 pr-4 text-base dlp-left-container font-rp-pn-regular -tracking-0.24 text-rp-primary-black d:w-2/3 d:pl-0 d:pr-0 d:text-17">
      <p className="font-rp-gelica-light leading-26px text-22 text-rp-primary-black mb-5">
        Popular on ResortPass
      </p>
      <div className="grid d:grid-cols-2 font-rp-pn-regular text-rp-gray">
        {hotels.map((hotel) => (
          <div className="my-3 pr-3" key={hotel.url_path}>
            <Link
              href={hotel.url_path}
              onClick={() => handleOnClick(hotel)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleOnClick(hotel);
                }
              }}
              title={`Visit ${hotel.title}`}
              style={{ color: '#252525' }}
              role="link"
              tabIndex={0}
            >
              {hotel.title}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
